/* Mobile Phone Market – scroll-in animations and header shadow.
   Safe to delete: content is fully visible without this file. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Header shadow after scrolling a little
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      document.documentElement.classList.toggle('mpm-scrolled', window.scrollY > 40);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if (reduce || !('IntersectionObserver' in window)) return;

  function setup() {
    var main = document.getElementById('main');
    if (!main) return;

    var targets = [];
    // Section headings and whole sections (skip the first section so the hero paints instantly)
    var sections = main.querySelectorAll('.shopify-section');
    sections.forEach(function (s, i) {
      if (i === 0) return;
      var head = s.querySelector('.section__header');
      if (head) targets.push({ el: head, delay: 0 });
    });
    // Product cards, brand circles, blog cards, trust icons: staggered
    var groups = [
      '.product-list .product-item',
      '.collection-list .collection-item',
      '.article-list .article-item',
      '.text-with-icons__item',
      '.featured-product .card, .featured-product .product-block-list'
    ];
    groups.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el, i) {
        if (el.closest('.shopify-section') === sections[0]) return;
        targets.push({ el: el, delay: Math.min(i % 6, 5) * 0.07 });
      });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    targets.forEach(function (t) {
      // Anything already on screen at load stays visible (no flash)
      var r = t.el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) return;
      t.el.style.setProperty('--mpm-delay', t.delay + 's');
      t.el.classList.add('mpm-reveal');
      io.observe(t.el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

/* Announcement bar ticker: rotate one message every 3.5s, pause on hover */
(function () {
  function start() {
    document.querySelectorAll('[data-mpm-ticker]').forEach(function (box) {
      var items = box.querySelectorAll('.mpm-ticker__item');
      if (items.length < 2) return;
      var i = 0, paused = false;
      box.addEventListener('mouseenter', function () { paused = true; });
      box.addEventListener('mouseleave', function () { paused = false; });
      setInterval(function () {
        if (paused || document.hidden) return;
        var cur = items[i];
        i = (i + 1) % items.length;
        var next = items[i];
        cur.classList.remove('is-active');
        cur.classList.add('is-leaving');
        next.classList.remove('is-leaving');
        next.classList.add('is-active');
        setTimeout(function () { cur.classList.remove('is-leaving'); }, 500);
      }, 3500);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
